import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}

const p2Style = {
  marginTop: 0,
  marginBottom: 5,
  paddingTop: 0,
}
export const sleepTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view Resident’s Total sleep time by day for the week specified above.</p>
    <p style={{...textStyle, ...p2Style}}>Click arrows above at right to toggle week view, back (&lt;) or forward (&gt;).</p>
  </Tooltip>
)

export const respirationTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view Resident’s respiration rate time in normal range, and above or below normal, by day for the week specified above.</p>
    <p style={{...textStyle, ...p2Style}}>Click arrows above at right to toggle week view, back (&lt;) or forward (&gt;).</p>
  </Tooltip>
)

export const outOfRangeTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>Click here to view Resident’s total time Out of Range (Out of Bed) by day for the week specified above.</p>
    <p style={{...textStyle, ...p2Style}}>Click arrows above at right to toggle week view, back (&lt;) or forward (&gt;).</p>
  </Tooltip>
)